"use client";

import type { ReactNode } from "react";
import { useFormStatus } from "react-dom";

/**
 * A submit button that shows its own form's pending state, for the forms a
 * SERVER page renders around a Server Action (Sign out, Continue with Google,
 * the admin's creation toggle). Disabled while pending, so a second press
 * cannot double-submit, and relabeled so the press is acknowledged on the
 * control itself (fleet DESIGN.md, "Async actions & progress").
 *
 * It must be rendered INSIDE the <form>: `useFormStatus` reads the nearest
 * enclosing form only.
 */
export function PendingSubmit({
  className,
  pendingLabel,
  children,
}: {
  className?: string;
  pendingLabel: ReactNode;
  children: ReactNode;
}) {
  const { pending } = useFormStatus();
  return (
    <button type="submit" className={className} disabled={pending} aria-busy={pending}>
      {pending ? pendingLabel : children}
    </button>
  );
}
